// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StaffTable_container__E4Iv0 {
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.StaffTable_clickable__a5zJQ {
  cursor: pointer;
}

.StaffTable_block__XdWBS {
  width: 100%;
  display: flex;
  align-items: center;
}

.StaffTable_header__RyEfO {
  width: 50%;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-left: 10px;
  padding-bottom: 12px;
}

.StaffTable_header__RyEfO::before {
  content: '';
  position: absolute;
  bottom: 11px;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: #e0e0e0;
}

.StaffTable_tabButton__FLGn8 {
  position: relative;
  background: none;
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  transition: all 0.2s ease;
}

.StaffTable_tabButton__FLGn8:hover {
  background-color: #f0f0f0;
  border-radius: 6px;
}

.StaffTable_active__zetTk {
  color: rgba(29, 135, 82, 1);
}

.StaffTable_active__zetTk::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: rgba(29, 135, 82, 1);
}


.StaffTable_workspace__hEs8A {
  position: fixed;
  text-align: left;
  top: 0;
  right: 0;
  width: 85%;
  height: 100vh;
  background: rgba(249, 249, 249, 1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 30px;
  animation: StaffTable_slideIn__GI32z 0.3s ease forwards;
}

/* Контейнер для дропбокса */
.StaffTable_dropdownWrapper__Jo91U {
  position: relative;
  display: inline-block;
}

/* Сам дропбокс */
.StaffTable_dropdown__c\\+Vem {
  position: absolute;
  top: 24px; /* чуть ниже иконки */
  right: 0;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  z-index: 10;
  width: 120px;
  overflow: hidden;
  animation: StaffTable_fadeIn__Op7tb 0.15s ease-out;
}

/* Анимация появления */
@keyframes StaffTable_fadeIn__Op7tb {
  from { opacity: 0; transform: translateY(-5px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Кнопки внутри дропбокса */
.StaffTable_dropdownBtn__ozuJl {
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  border: none;
  background-color: #fff;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s, color 0.2s;
}

.StaffTable_dropdownBtn__ozuJl:hover {
  background-color: #f0f0f0;
  color: #333;
}

/* Иконка вертикальных троеточий */
.StaffTable_iconCell__TefUK svg {
  cursor: pointer;
  transition: transform 0.2s;
}

.StaffTable_iconCell__TefUK svg:hover {
  transform: rotate(90deg);
  color: #555;
}


.StaffTable_add__PqINw {
  position: absolute;
  top: 1.9rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.StaffTable_tableWrapper__pj0bS {
  max-height: 40vh;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e6e9eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 6px rgba(0,0,0,0.04);
}

.StaffTable_table__y-T8q {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.StaffTable_table__y-T8q thead th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #fafafa;
  padding: 12px 14px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #e6e9eb;
}

.StaffTable_table__y-T8q th, .StaffTable_table__y-T8q td {
  padding: 12px 14px;
  border-bottom: 1px solid #f1f3f5;
  text-align: left;
  vertical-align: middle;
}

.StaffTable_table__y-T8q tr:hover {
  background: #fbfbfb;
}

`, "",{"version":3,"sources":["webpack://./src/pages/StaffPages/StaffTable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,sCAAsC;AACxC;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,aAAa;EACb,kCAAkC;EAClC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,uDAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS,EAAE,qBAAqB;EAChC,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kDAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".container {\n  padding: 10px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.block {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n\n.header {\n  width: 50%;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin-left: 10px;\n  padding-bottom: 12px;\n}\n\n.header::before {\n  content: '';\n  position: absolute;\n  bottom: 11px;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: #e0e0e0;\n}\n\n.tabButton {\n  position: relative;\n  background: none;\n  border: none;\n  padding: 10px 16px;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tabButton:hover {\n  background-color: #f0f0f0;\n  border-radius: 6px;\n}\n\n.active {\n  color: rgba(29, 135, 82, 1);\n}\n\n.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: rgba(29, 135, 82, 1);\n}\n\n\n.workspace {\n  position: fixed;\n  text-align: left;\n  top: 0;\n  right: 0;\n  width: 85%;\n  height: 100vh;\n  background: rgba(249, 249, 249, 1);\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  animation: slideIn 0.3s ease forwards;\n}\n\n/* Контейнер для дропбокса */\n.dropdownWrapper {\n  position: relative;\n  display: inline-block;\n}\n\n/* Сам дропбокс */\n.dropdown {\n  position: absolute;\n  top: 24px; /* чуть ниже иконки */\n  right: 0;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\n  z-index: 10;\n  width: 120px;\n  overflow: hidden;\n  animation: fadeIn 0.15s ease-out;\n}\n\n/* Анимация появления */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-5px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Кнопки внутри дропбокса */\n.dropdownBtn {\n  width: 100%;\n  padding: 8px 12px;\n  text-align: left;\n  border: none;\n  background-color: #fff;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.dropdownBtn:hover {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n/* Иконка вертикальных троеточий */\n.iconCell svg {\n  cursor: pointer;\n  transition: transform 0.2s;\n}\n\n.iconCell svg:hover {\n  transform: rotate(90deg);\n  color: #555;\n}\n\n\n.add {\n  position: absolute;\n  top: 1.9rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.tableWrapper {\n  max-height: 40vh;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e6e9eb;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.04);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n  background: #fafafa;\n  padding: 12px 14px;\n  font-weight: 600;\n  color: #333;\n  border-bottom: 1px solid #e6e9eb;\n}\n\n.table th, .table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid #f1f3f5;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.table tr:hover {\n  background: #fbfbfb;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StaffTable_container__E4Iv0`,
	"clickable": `StaffTable_clickable__a5zJQ`,
	"block": `StaffTable_block__XdWBS`,
	"header": `StaffTable_header__RyEfO`,
	"tabButton": `StaffTable_tabButton__FLGn8`,
	"active": `StaffTable_active__zetTk`,
	"workspace": `StaffTable_workspace__hEs8A`,
	"slideIn": `StaffTable_slideIn__GI32z`,
	"dropdownWrapper": `StaffTable_dropdownWrapper__Jo91U`,
	"dropdown": `StaffTable_dropdown__c+Vem`,
	"fadeIn": `StaffTable_fadeIn__Op7tb`,
	"dropdownBtn": `StaffTable_dropdownBtn__ozuJl`,
	"iconCell": `StaffTable_iconCell__TefUK`,
	"add": `StaffTable_add__PqINw`,
	"tableWrapper": `StaffTable_tableWrapper__pj0bS`,
	"table": `StaffTable_table__y-T8q`
};
export default ___CSS_LOADER_EXPORT___;
